import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  Row,
  Col,
  Select,
  Divider,
  useSelect,
  Button,
  Spin,
  Space,
} from '@pankod/refine-antd'
import { useCreateMany, useGetIdentity, useTable } from '@pankod/refine-core'
import 'styles/custom.css'
import type { RangePickerProps } from 'antd/es/date-picker'
import {
  IGrade,
  ISubject,
 
  ITopic,
  IBloomLevel,
 
  IDifficultyLevel,
  IQuestion,
  
  IReportTheme,
  ITheme,
  ISubTheme,
 
  INotification,
  IWorkRequestReviewer,
  IWorkRequestApprover,
  ICompetency,
  IStrand,
  ITNTaxonomy,
  IWorkRequestGrades,
} from 'interfaces'
import sendEmail from 'sendmail'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import {  getLastCreatedWorkRequest } from 'gql/mutations'
import React from 'react'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'
import { getReportThemeBySubject } from 'gql/query'
import { useUserContext } from 'context/user'
import  { useBloomsLevel, useCompetency, useDifficultyLevels, useGrades, useSubjects,useReportTheme } from 'utility/masterData'
type CreateWorkRequestProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  refreshData: any
  close: any
}

export const CloneWorkRequest: React.FC<CreateWorkRequestProps> = ({ modalProps, formProps, record, refreshData, close }) => {
  const { data: user } = useGetIdentity()
  const { userRole,qcreatorList,qapproverList,qreviewerList,vcreatorList } = useUserContext()
 
  const [saveAsDraft, setSaveDraft] = useState(false)
  const [disableSaveBtn, setDisableSaveBtn] = useState(false)
  const [requestType, setRequestType] = useState('')

  const [reportThemeData, setReportThemeData] = useState([] as any[])
  const [selectedReviewers, setSelectedReviewers] = useState<string[]>([])
  const [reviewers, setReviewers] = useState<object[]>([])
  const [selectedReviewerIds, setSelectedReviewerIDS] = useState<string[]>([])
  const [allReviewers, setAllReviewers] = useState<object[]>([])
  const [totalVariantCount, setTotalVariantCount] = useState(0)
  const [questionCount, setQuestionCount] = useState(5)
  const [taxonomyfilter, setTaxonomyFilter] = useState([])
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [showApprover, setShowApprover] = useState<boolean>(true)
  const [subjectFilter, setSubjectFilter] = useState<any[]>([])
  const [questionQueryEnabled,setQuestionQueryEnabled]= useState<boolean>(false)
  const [themeQueryEnabled,seThemeQueryEnabled]= useState<boolean>(false)
  const [subThemeQueryEnabled,setSubThemeQueryEnabled]= useState<boolean>(false)
  const [TopicQueryEnabled,setTopicQueryEnabled]= useState<boolean>(false)
  const [reportThemeQueryEnabled,setReportThemeQueryEnabled]= useState<boolean>(false)
  const [subjectSearchValue, setSubjectSearchValue] = useState("");
  var notification_arr: object[] = []
  var mail_arr: object[] = []
  const [validation, setValidation] = useState({
    question_type_id: true,
    subject_id: true,
    creator_id: true,
  })

  const { mutate } = useCreateMany<INotification>()
 

  const { mutate: createReviewers } = useCreateMany<IWorkRequestReviewer>()
  const { mutate: createApprovers } = useCreateMany<IWorkRequestApprover>()
  const { mutate: createGrades } = useCreateMany<IWorkRequestGrades>()
  const  gradeSelectProps =useGrades(modalProps?.visible)
  const bloomlevelSelectProps=useBloomsLevel(modalProps?.visible);
  const difficultylevelSelectProps=useDifficultyLevels(modalProps?.visible);
  const subjectSelectProps =useSubjects(modalProps?.visible)
  const competencySelectProps=useCompetency(modalProps?.visible)
  

  const onFinish = async (values: any) => {
    setDisableSaveBtn(true)
    let approverData: object[] = []
    let allApproverData: object[] = []
    allReviewers.map((item: any, i: any) => {
      delete values['approver_ids_' + i]
      delete values['reviwer_id_selected_' + i]

      if (selectedReviewerIds.includes(item?.reviewer?.id)) {
        item?.ap_ids.map((ids: any) => {
          allApproverData.push(ids)
        })
        approverData.push({ reviwer_id_selected: item?.reviewer?.id, approver_ids: item?.ap_ids })
      }
    })

    if (JSON.stringify(values?.reviewer_ids) !== '{}' && values?.reviewer_ids !== null && values?.reviewer_ids !== undefined) {
      values?.reviewer_ids.map((item: any) => {
        notification_arr.push({
          description: `You are assigned as reviewer for work request ${values?.name} as reviewer`,
          sender: user?.id,
          recepient: item,
          source_name: 'work_requests',
          title: 'New Task',
          recepient_user_role: 'qreviewer',
        })
        let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === item)[0]
        mail_arr.push({
          subject: 'Work Request Created and assigned to you',
          to: [{ name: reviewerDetails?.displayName, email: reviewerDetails?.email }],
          htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. Questions to review will assign shortly.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
        })
      })
    }
    if (values?.approver_ids !== null && values?.approver_ids !== undefined && JSON.stringify(values?.approver_ids) !== '{}') {
      values?.approver_ids?.map((item: any) => {
        item?.approver_ids.map((approver: any) => {
          notification_arr.push({
            description: `You are assigned as approver for work request ${values?.name}`,
            sender: user?.id,
            recepient: approver,
            source_name: 'work_requests',
            title: 'New Task',
            recepient_user_role: 'qapprover',
          })
          let approverDetails = qapproverList.filter((appUser: any) => appUser?.id === approver)[0]
          mail_arr.push({
            subject: 'Work Request Created and assigned to you',
            to: [{ name: approverDetails?.displayName, email: approverDetails?.email }],
            htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. Question to approve will assign shortly.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
          })
        })
      })
    }
    if (values?.creator_id !== '' && values?.creator_id !== null && values?.creator_id !== undefined) {
      notification_arr.push({
        description: 'Work Request created and assigned to you',
        sender: user?.id,
        recepient: values?.creator_id,
        source_name: 'work_requests',
        title: 'New Task',
        recepient_user_role: requestType === 'Q' ? 'qcreator' : 'variantcreator',
      })
      let creatorDetails = []
      if (requestType === 'Q') {
        creatorDetails = qcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }
      if (requestType === 'V') {
        creatorDetails = vcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }

      mail_arr.push({
        subject: 'Work Request Created and assigned to you',
        to: [{ name: creatorDetails?.displayName, email: creatorDetails?.email }],
        htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. You have to create ${values?.count} questions.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
      })
    }
    let count = questionCount
    if (requestType === 'V') {
      count = 0
      values?.variant_options?.map((item: any) => {
        count = count + parseInt(item?.variant_count)
      })
    }
    formProps.form?.resetFields()
    setAllReviewers([])
    if (saveAsDraft === true) {
      setSaveDraft(false)
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          status: 'Draft',
          subject_id: values?.subject_id !== '' ? values?.subject_id : null,
          question_type_id: values?.question_type_id !== '' ? values?.question_type_id : null,
          creator_id: values?.creator_id !== '' ? values?.creator_id : null,
          count: count,
          approver_ids: approverData,
          all_approver_ids: allApproverData,
        })
      )
    } else {
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          status: 'Open',
          count: count,
          approver_ids: approverData,
          all_approver_ids: allApproverData,
        })
      )
    }
  }

  const { filters, setFilters, tableQueryResult, sorter } = useTable<ITopic>({
    resource: 'topics',
    queryOptions:{enabled:TopicQueryEnabled && modalProps?.visible},
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    queryOptions:{enabled:themeQueryEnabled && modalProps?.visible},
    resource: 'themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    queryOptions:{enabled:subThemeQueryEnabled && modalProps?.visible},
    resource: 'sub_themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'theme_id'] },
  })
  const {
    filters: questionFilter,
    setFilters: setQuestionFilters,
    tableQueryResult: questionResult,
  } = useTable<IQuestion>({
    resource: 'questions',
    queryOptions:{
      enabled:questionQueryEnabled && modalProps?.visible
    },
    metaData: { fields: ['id', 'title'] },
    initialPageSize: 1000,
  })
  const reportThemeSelectProps=useReportTheme(modalProps?.visible, subjectFilter )
  // const { selectProps: reportThemeSelectProps } = useSelect<IReportTheme>({
  //   queryOptions: { staleTime:  Infinity, enabled:reportThemeQueryEnabled && modalProps?.visible},
  //   resource: 'report_themes',
  //   // defaultValueQueryOptions:{},
  //   fetchSize: 1000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   filters: subjectFilter,
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  

  useEffect(() => {
    setDisableSaveBtn(false)
    setQuestionFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: record?.subject_id,
      },
    ])
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: record?.report_theme_id,
      },
    ])
    setQuestionQueryEnabled(true)
    seThemeQueryEnabled(true)
  }, [record])

  useEffect(() => {
    if(record?.id){
    let data: any = [
      
      {
        field: 'subject_id',
        operator: 'eq',
        value: record?.subject_id,
      },
    ]
    setSubjectFilter(data)
    setReportThemeQueryEnabled(true);
  }
  }, [record])

  useEffect(() => {
    if (record?.theme_id !== '' || record?.theme_id !== null) {
      subThemeFilters.pop()
      setSubThemeFilters([
        {
          field: 'theme_id',
          operator: 'eq',
          value: record?.theme_id,
        },
      ])
      setSubThemeQueryEnabled(true)
    }
  }, [record])
  useEffect(() => {
    if (record?.sub_theme_id !== '' || record?.sub_theme_id !== null) {
      filters.push({
        field: 'sub_theme_id',
        operator: 'eq',
        value: record?.sub_theme_id,
      })
      setFilters(filters)
      setTopicQueryEnabled(true)
    }
  }, [record])
 

  
  useEffect(() => {
    setRequestType(record?.request_type)
    if (record?.request_type === 'Q') {
      setQuestionCount(record?.count)
    } else {
      setTotalVariantCount(record?.count)
    }
  }, [record])
  const handleRequestType = (value: any) => {
    setRequestType(value)
    formProps?.form?.setFieldsValue({
      creator_id: null,
    })
  }
  const handleReportThemeChange = (value: { value: any }) => {
    themeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
    })
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleSubjectChange = (value: { value: any }) => {
    setSubjectFilter([])
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
      report_theme_id: null,
    })
    themeFilters.pop()
    questionFilter.pop()
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ]
    setSubjectFilter(data)
   
    setQuestionFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
    getReportThemeBySubject(value).then((resp: any) => {
      setReportThemeData(resp?.report_themes)
    })
  }
  const handleThemeChange = (value: { value: any }) => {
    formProps.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
    })
    subThemeFilters.pop()
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleSubThemeChange = (value: { value: any }) => {
    formProps.form?.setFieldsValue({
      topic_id: null,
    })
    filters.pop()
    setFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  useEffect(() => {
    let arr: object[] = []
    let ids: string[] = []
    let r_arr: object[] = []
    let appr_list: any[] = []
    let ap_ids: any[] = []
    if (record?.approver_ids?.length > 0) {
      setShowApprover(true)
    }
    record?.approver_ids?.length > 0 &&
      record?.approver_ids?.map((item: any) => {
        ap_ids = []
        appr_list = []

        ids.push(item?.reviwer_id_selected)
        item?.approver_ids.map((appr: any) => {
          ap_ids.push(appr)
          const result1 = qapproverList?.filter((list: any) => list?.id === appr)[0]
          appr_list.push(result1)
        })

        const result = qreviewerList?.filter((list: any) => list?.id === item?.reviwer_id_selected)[0]
        arr.push({ reviewer: result, approver_ids: appr_list, ap_ids: ap_ids })
        r_arr.push(result)
      })

    setSelectedReviewerIDS(ids)

    setAllReviewers(arr)
    setReviewers(arr)
    // setSelectedReviewerList(ids)
  }, [record])

  const reviewerChange = (value: string[]) => {
    let arr: object[] = []
    let ids: string[] = []
    let all_data: object[] = [...allReviewers]
    let new_data: object[] = []

    if (value?.length > 0) {
      for (let i = 0; i < value?.length; i++) {
        const result = qreviewerList?.filter((item: any) => item?.id === value[i])[0]
        arr.push(result)
        ids.push(value[i])
      }

      if (value?.length > selectedReviewerIds?.length) {
        let result_data = ids.filter(e => !allReviewers.find((item: any) => e == item.reviewer?.id))
        const data = qreviewerList?.filter((list: any) => list?.id === result_data[0])[0]

        all_data.push({ reviewer: data, approver_ids: [], ap_ids: [] })
      }
      if (value?.length < selectedReviewerIds?.length) {
        all_data = all_data.filter((item: any) => ids.includes(item?.reviewer?.id))
      }
      ids = ids.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })

      setAllReviewers(all_data)
      setSelectedReviewerIDS(ids)
    } else {
      setAllReviewers([])
      setSelectedReviewerIDS([])
    }

    // setReviewers(arr)
  }
  const { selectProps: tntaxonomySelectProps } = useSelect<ITNTaxonomy>({
    queryOptions: {enabled: modalProps?.visible },
    resource: 'tn_taxonomys',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: taxonomyfilter,
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: strandSelectProps } = useSelect<IStrand>({
    queryOptions: { enabled:modalProps?.visible },
    resource: 'strands',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'teacher_level_id', 'taxonomy_id', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: strandfilter,
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const handleCompetencyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      taxonomy_id: null,
      teacher_level_id: null,
      strand_id: null,
    })
    let data: any = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: value,
      },
    ]
    setTaxonomyFilter(data)
    setStrandFilter(data)
  }
  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && current < dayjs()
  }
  const handleTaxonomyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      teacher_level_id: null,
      strand_id: null,
    })
    let arr: any[] = [...strandfilter]
    let data: any = {
      field: 'taxonomy_id',
      operator: 'eq',
      value: value,
    }
    arr.push(data)

    setStrandFilter(arr)
  }

  
  useEffect(() => {
    let arr: any[] = [...strandfilter]
    if (record?.comptency_id !== '' && record?.comptency_id !== null && record?.comptency_id !== undefined) {
      let data: any = [
        {
          field: 'competency_id',
          operator: 'eq',
          value: record?.comptency_id,
        },
      ]
      setTaxonomyFilter(data)
      // setStrandFilter(data)
    }
    if (record?.taxonomy_id !== '' && record?.taxonomy_id !== null && record?.taxonomy_id !== undefined) {
      let data: any = {
        field: 'taxonomy_id',
        operator: 'eq',
        value: record?.taxonomy_id,
      }
      arr.push(data)
      // setStrandFilter(arr)
    }
    if (record?.teacher_level_id !== '' && record?.teacher_level_id !== null && record?.teacher_level_id !== undefined) {
      let data: any = {
        field: 'teacher_level_id',
        operator: 'eq',
        value: record?.teacher_level_id,
      }
      arr.push(data)
    }
    setStrandFilter(arr)
  }, [record])
  // const getValueToRemove = () => {
  //   if (removedReviewerIds.length > 0) {
  //     let result: number[] = field_arr.filter((x: any) => !removedReviewerIds.includes(x))
  //     return result[0]
  //   } else return -1
  //   //   field_arr.filter((x: any) => !removedReviewerIds.includes(x))
  //   // }
  // }
  const addApprover = () => {
    setShowApprover(true)
  }
  const changeApprover = (value: string[], rid: string) => {
    // let data = [...allReviewers]
    allReviewers.map((item: any, index: any) => {
      if (item?.reviewer?.id === rid) {
        let app_data: object[] = []
        let app_ids: string[] = []
        if (app_ids === undefined) {
          app_ids = []
        }
        for (let i = 0; i < value?.length; i++) {
          app_data.push(qapproverList?.filter((list: any) => list?.id === value[i])[0])

          app_ids.push(qapproverList?.filter((list: any) => list?.id === value[i])[0]?.id)
          app_data = app_data.filter((thing: any, index: any, self: any) => index === self.findIndex((t: any) => t.id === thing.id))
          app_ids = app_ids.filter(function (item, index, inputArray) {
            return inputArray.indexOf(item) == index
          })
        }
        item['approver_ids'] = app_data
        item['ap_ids'] = app_ids
      }
    })
    // setReloadApproverData(true)
    // setAllReviewers(data)
  }
  return (
    <Modal {...modalProps} title="Clone Work Request" okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => {
          let work_request_id = ''
          onFinish(values).then(response => {
            getLastCreatedWorkRequest()
              .then((resp: any) => {
                work_request_id = resp?.work_requests[0]?.id
              })
              .then(() => {
               
                if (!saveAsDraft) {
                  sendEmail(mail_arr)
                  notification_arr.map((item: any) => {
                    item['redirect_id'] = work_request_id
                    item['redirect_component'] = 'show'
                  })
                  mutate({
                    resource: 'notifications',
                    values: notification_arr,
                  })
                }
              })
              .then(() => {
                let grade_array: object[] = []
                if (values?.grade_ids?.length > 0) {
                  values?.grade_ids?.map((item: any) => {
                    grade_array.push({
                      grade_id: item,
                      work_request_id: work_request_id,
                    })
                  })

                  createGrades({
                    resource: 'work_request_grades',
                    values: grade_array,
                  })
                }
                setDisableSaveBtn(false)
              })
              .then(() => {
                // createUserHistory('work_requests', 'clone', work_request_id, user?.id, userRole)
                refreshData()
              })
          })
        }}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Work Request Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={16}>
            <Form.Item label="Description" name="description">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Request Type" name="request_type" initialValue={'Q'} rules={[{ required: true }]}>
              <Select
                allowClear
                onChange={handleRequestType}
                options={[
                  { label: 'Question', value: 'Q' },
                  { label: 'Variant', value: 'V' },
                ]}
              />
            </Form.Item>
          </Col>
         
          <Col xs={24} lg={8}>
            <Form.Item
              label="Due Date"
              name="due_date"
              rules={[{ required: false }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker style={{ width: '100%' }} disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Grade" name="grade_ids" rules={[{ required: false }]}>
              <Select {...gradeSelectProps} mode="multiple" allowClear showSearch={false} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>


          <Col xs={24} lg={8}>
            <Form.Item label="Subject" name="subject_id" rules={[{ required: validation?.subject_id }]}>
              <Select {...subjectSelectProps} onChange={handleSubjectChange} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Report Theme (TN_Term_Month)" name="report_theme_id" rules={[{ required: false }]}>
              <Select
                disabled={
                  formProps?.form?.getFieldValue('subject_id') === undefined || formProps?.form?.getFieldValue('subject_id') == null ? true : false
                }
                showSearch
              
                {...reportThemeSelectProps}
                onChange={handleReportThemeChange}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Theme(TN Chapter Name)" name="theme_id" rules={[{ required: false }]}>
              <Select
                onChange={handleThemeChange}
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                disabled={
                  formProps?.form?.getFieldValue('report_theme_id') === undefined || formProps?.form?.getFieldValue('report_theme_id') == null
                    ? true
                    : false
                }
              >
                {themeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Sub Theme(CENTA Concept ID_CENTA Concept Name)" name="sub_theme_id" rules={[{ required: false }]}>
              <Select
                onChange={handleSubThemeChange}
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                disabled={
                  formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false
                }
              >
                {subThemeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Topic (TN Taxonomy ID/s)" name="topic_id" rules={[{ required: false }]}>
              {/* <TopicSelector /> */}
              {/* <Select {...topicSelectProps} /> */}
              <Select
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                disabled={
                  formProps?.form?.getFieldValue('sub_theme_id') === undefined || formProps?.form?.getFieldValue('sub_theme_id') == null
                    ? true
                    : false
                }
              >
                {tableQueryResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {requestType === 'Q' ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Number of questions (Fill in with either 9 or 25)"
                name="count"
                initialValue={questionCount}
                rules={[{ required: true }]}
              >
                <Input onChange={e => setQuestionCount(parseInt(e.target.value))} />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
        <Row gutter={[16, 0]}>
          {requestType === 'Q' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the creator's name" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onChange={() => setResetCreatorData(true)}
                // filterOption={false}
                >
                  {qcreatorList?.length > 0 &&
                    qcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          ) : (
            <Col xs={24} lg={8}>
              <Form.Item label="Variant Creator" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  // onChange={() => setResetVCreatorData(true)}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                // filterOption={false}
                >
                  {vcreatorList?.length > 0 &&
                    vcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
                {/* <Select />{" "} */}
              </Form.Item>
            </Col>
          )}
          <Col xs={24} lg={8}>
            <Form.Item
              label="Choose the reviewer's name (if known)"
              name="reviewer_ids"
              rules={[{ required: false }]}
              initialValue={selectedReviewers}
            >
              <Select
                allowClear
                showSearch
                // showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                mode="multiple"
                onChange={(value: any) => reviewerChange(value)}
                defaultValue={selectedReviewerIds?.length > 0 ? selectedReviewerIds : []}
              >
                {qreviewerList?.length > 0 &&
                  qreviewerList?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            {showApprover
              ? allReviewers?.length > 0 &&
              allReviewers.map((elem: any, i: any) => (
                <Row
                  key={i}
                  gutter={[16, 0]}
                  style={{ display: selectedReviewerIds?.length > 0 && !selectedReviewerIds.includes(elem?.reviewer?.id) ? 'none' : 'flex' }}
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Reviewer"
                      name={'reviwer_id_selected_' + i}
                      rules={[
                        {
                          required: false,
                          message: 'Select a Reviewer',
                        },
                      ]}
                    >
                      <Input placeholder={elem?.reviewer?.displayName} defaultValue={elem?.reviewer?.displayName} readOnly />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={8}>
                    <Form.Item
                      label="Choose the approver's name (if known)"
                      name={'approver_ids_' + i}
                      rules={[{ required: false, message: 'Select an Approver' }]}
                    >
                      <Select
                        allowClear
                        showSearch
                        filterOption={(input: any, option: any) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                          option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        // filterOption={false}
                        mode="multiple"
                        defaultValue={elem?.ap_ids}
                        onChange={(value: any) => changeApprover(value, elem?.reviewer?.id)}
                      >
                        {qapproverList?.length > 0 &&
                          qapproverList?.map(item => (
                            <option key={item?.id} value={item?.id}>
                              {item?.displayName}
                            </option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              ))
              : null}
            <Form.Item>
              <Button type="dashed" onClick={() => addApprover()} block icon={<PlusOutlined />}>
                Add Approver
              </Button>
            </Form.Item>
          </Col>

          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Tags
            </Divider>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Competency" name="competency_id" rules={[{ required: false }]}>
              <Select onChange={handleCompetencyChange} {...competencySelectProps} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Taxonomy" name="taxonomy_id" rules={[{ required: false }]}>
              <Select onChange={handleTaxonomyChange} {...tntaxonomySelectProps} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Standard" name="strand_id" rules={[{ required: false }]}>
              <Select {...strandSelectProps} allowClear />
            </Form.Item>
          </Col>
         

          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate Bloom's taxonomy level" name="bloom_level_id" rules={[{ required: false }]}>
              <Select {...bloomlevelSelectProps} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" rules={[{ required: false }]}>
              <Select {...difficultylevelSelectProps} allowClear />
            </Form.Item>
          </Col>

         
          {requestType === 'V' ? (
            <>
              <Col xs={24} lg={24}>
                <Divider orientation="left" orientationMargin="0" className="primary">
                  Add Variants
                </Divider>
              </Col>
              <Col xs={24} lg={24}>
                <Form.List name="variant_options">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row gutter={[16, 0]}>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              {...restField}
                              label="Variant Question"
                              name={[name, 'question_id']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Missing Variant Question',
                                },
                              ]}
                            >
                              <Select allowClear>
                                {questionResult?.data?.data?.map(item => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.title}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={8}>
                            <Form.Item
                              {...restField}
                              label="Variant Count"
                              name={[name, 'variant_count']}
                              rules={[{ required: true, message: 'Missing Count' }]}
                            >
                              <Input placeholder="Variant Count" type="small" />
                            </Form.Item>
                          </Col>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Row>
                        // </Space>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Add Variants
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </>
          ) : null}
          <Form.Item name="created_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
        <Divider />
        <Row gutter={[16, 0]} justify="end" align="top">
          <Spin spinning={disableSaveBtn}></Spin>
          <Col xs={24} lg={8} style={{ display: 'flex', justifyContent: 'end' }}>
            <Space>
              <Button onClick={() => close()}>Cancel</Button>
              <Button type="primary" htmlType="submit" disabled={disableSaveBtn}>
                Submit
              </Button>
              <Button
                className="save-draft-btn"
                htmlType="submit"
                onClick={() => {
                  setValidation({ question_type_id: false, subject_id: false, creator_id: false })
                  setSaveDraft(true)
                }}
              >
                Save Draft
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
